<template>
  <el-dialog
      :model-value="props.visible"
      title="全年一次性奖金收入 新增"
      width="960"
      top="6vh"
      destroy-on-close
      :close-on-click-modal="false"
      @open="onOpen"
      @closed="closedModal"
  >
    <div v-loading="pageLoading">
      <div style="max-height: calc(80vh - 100px);overflow-y: auto;">
        <el-form :model="formData" ref="formRef" :rules="rules" :inline="true" label-width="100px">
          <div class="form-block">
            <div class="block-title">
              基本信息
            </div>

            <div class="block-content">
              <el-form-item label="工号" prop="employeesNo">
                <el-input
                    v-model="formData.employeesNo"
                    placeholder="请输入"
                    style="width: 180px"
                    maxlength="30"
                    clearable
                />
              </el-form-item>

              <el-form-item label="证照类型" prop="certificateType">
                <el-select
                    v-model="formData.certificateType"
                    disabled
                    style="width: 180px"
                    placeholder="请选择">
                  <el-option label="居民身份证" value="居民身份证"/>
                  <el-option label="中国护照" value="中国护照"/>
                </el-select>
              </el-form-item>

              <el-form-item label="所属期间起" prop="dateStart">
                <el-date-picker
                    type="date"
                    model-value="2024-01-01"
                    format="YYYY-MM-DD"
                    disabled
                    value-format="YYYY-MM-DD"
                    clearable
                    style="width: 180px"
                />
              </el-form-item>

              <el-form-item label="姓名" prop="name">
                <el-select
                    v-model="formData.name"
                    style="width: 180px"
                    placeholder="请选择"
                    @change="changePerson"
                >
                  <el-option
                      v-for="item in nameOptions"
                      :key="item.idNumber"
                      :label="item.name"
                      :value="item.idNumber"/>
                </el-select>
              </el-form-item>

              <el-form-item label="证照号码" prop="idNumber">
                <el-input
                    v-model="formData.idNumber"
                    placeholder="请输入"
                    style="width: 180px"
                    readonly
                    maxlength="30"
                    clearable
                />
              </el-form-item>

              <el-form-item label="所属期间止" prop="dateEnd">
                <el-date-picker
                    type="date"
                    model-value="2024-01-31"
                    format="YYYY-MM-DD"
                    disabled
                    value-format="YYYY-MM-DD"
                    clearable
                    style="width: 180px"
                />
              </el-form-item>
            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              收入及减除费用
            </div>

            <div class="block-content">
              <el-form-item label="全年一次性奖金额" label-width="140px" prop="Answer_CurrentIncome">
                <el-input-number
                    v-model="formData.Answer_CurrentIncome"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="免税收入" prop="Answer_CurrentExemptIncome">
                <el-input-number
                    v-model="formData.Answer_CurrentExemptIncome"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>
            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              本期其他扣除
            </div>

            <div class="block-content">
              <el-form-item label="其他" prop="Answer_Other">
                <el-input-number
                    v-model="formData.Answer_Other"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="小计" prop="Answer_SmallTotal">
                <el-input-number
                    v-model="formData.Answer_SmallTotal"
                    :precision="2"
                    class="num-input"
                    disabled
                    :controls="false"
                />
              </el-form-item>
            </div>
          </div>

          <div class="form-block">
            <div class="block-title">
              本期其他
            </div>

            <div class="block-content">
              <el-form-item label="准予扣除的捐赠额" label-width="130px" prop="Answer_PreDeductibleContributions">
                <el-input-number
                    v-model="formData.Answer_PreDeductibleContributions"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="减免税额" prop="TaxRelief">
                <el-input-number
                    v-model="formData.TaxRelief"
                    :precision="2"
                    class="num-input"
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="已缴税额" prop="Answer_TheAmountTaxWithheld">
                <el-input-number
                    v-model="formData.Answer_TheAmountTaxWithheld"
                    :precision="2"
                    class="num-input"
                    disabled
                    :controls="false"
                />
              </el-form-item>

              <el-form-item label="备注" label-width="130px" prop="Answer_Remark">
                <el-input
                    v-model="formData.Answer_Remark"
                    placeholder="请输入"
                    style="width: 730px"
                    maxlength="30"
                    clearable
                />
              </el-form-item>
            </div>
          </div>

        </el-form>
      </div>

      <div class="my-footer">
        <el-button @click="emit('update:visible', false)">取消</el-button>
        <el-button type="primary" style="margin-right: 15px;" @click="onConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {ElMessage} from "element-plus";
import {useTaxStore} from "@/store/modules/tax.js";
const taxStore = useTaxStore();
const { userAnswer } = storeToRefs(taxStore);

const props = defineProps({
  visible: {
    type: Boolean,
    required: true
  },
  currentRow: {
    type: Object,
    default: () => {
    }
  },
})

const pageLoading = ref(false)
const formData = ref({
  Answer_CurrentExemptIncome: 0.00,
  Answer_Other: 0.00,
  Answer_SmallTotal: 0.00,
  Answer_PreDeductibleContributions: 0.00,
  TaxRelief: 0.00,
  Answer_TheAmountTaxWithheld: 0.00,
  certificateType: '居民身份证',
  total_kc: 0.00,
})
const rules = reactive({
  Answer_CurrentIncome: [
    {required: true, message: '请输入', trigger: 'blur'},
  ],
  name: [
    {required: true, message: '请选择', trigger: 'change'},
  ]
})

const nameOptions = computed(() => {
  return taxStore.personCollectionList.length && taxStore.personCollectionList.filter(f => f.employeeType == '雇员')  || []
})

function onOpen() {

}

function changePerson(val) {
  const person = nameOptions.value.find(f=> f.idNumber == val) || {}
  formData.value.idNumber = person.idNumber
  formData.value.employeesNo = person.employeesNo
  formData.value.name = person.name
}

const formRef = ref()

const emit = defineEmits(['update:visible', 'refresh'])

async function onConfirm() {
  await formRef.value.validate(valid => {
    if (valid) {
      if(userAnswer.value.some(s => s.idNumber == formData.value.idNumber)) {
        ElMessage.warning('重复添加')
        return
      }
      emit('update:visible', false)
      emit('confirm', formData.value)
    }
  })
}

function closedModal() {
  emit('update:visible', false)
  formData.value = {
    Answer_CurrentExemptIncome: 0.00,
    Answer_Other: 0.00,
    Answer_SmallTotal: 0.00,
    Answer_PreDeductibleContributions: 0.00,
    TaxRelief: 0.00,
    Answer_TheAmountTaxWithheld: 0.00,
    certificateType: '居民身份证',
    total_kc: 0.00,
  }
}
</script>

<style scoped lang="scss">
.form-block {
  .block-title {
    color: #000;
    font-size: 16px;
    border-left: 5px solid #4285F4;
    padding-left: 8px;
    line-height: 20px;
    margin-bottom: 15px;
  }

  .block-content {
    padding-left: 20px;

    .el-form-item {
      margin-right: 15px;
    }

    :deep(.num-input) {
      width: 170px;

      .el-input__inner {
        text-align: left;
      }
    }
  }
}

.my-footer {
  display: flex;
  flex-direction: row-reverse;
  margin-top: 30px;
}
</style>
